module.exports = __webpack_public_path__ + "static/exterior-0275aea169dbed83d2bd23213ec07b7a.jpg";